module.exports = __webpack_public_path__ + "img/tick.ae3629cc.svg";